'use strict';
import {CartEntryPoint} from './CartEntryPoint';
import {DesignCenterEntryPoint} from './DesignCenterEntryPoint';
import {LivePersonEntryPoint} from './LivePersonEntryPoint';
import {VideoDeskEntryPoint} from './VideoDeskEntryPoint';
import {WWWEntryPoint} from './WWWEntryPoint';

const entryPoints = {
  cart: new CartEntryPoint(),
  designCenter: new DesignCenterEntryPoint(),
  livePerson: new LivePersonEntryPoint(),
  videoDesk: new VideoDeskEntryPoint(),
  www: new WWWEntryPoint()
};

export default entryPoints;



// WEBPACK FOOTER //
// ./assets/entryPoints/index.js